import { render, staticRenderFns } from "./AttributesList.vue?vue&type=template&id=36be38cc&scoped=true&"
import script from "./AttributesList.vue?vue&type=script&lang=js&"
export * from "./AttributesList.vue?vue&type=script&lang=js&"
import style0 from "./AttributesList.vue?vue&type=style&index=0&id=36be38cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be38cc",
  null
  
)

export default component.exports